import { IconPointFilled } from "@tabler/icons-react"
import { ellipsify } from "../../../../utils/ellipsify"
import { Group, ThemeIcon, Text, Tooltip } from "@mantine/core"
import { getLogLevelColor } from "./logLevelFunctions"

export type LogLevel = "Information" | "Warning" | "Error" | "Debug"

interface LogLevelProps {
  value: LogLevel
}

export function LogLevel({ value }: LogLevelProps) {
  const logLevelColor = getLogLevelColor(value)
  return (
    <Group gap={"xs"} wrap="nowrap" c={logLevelColor}>
      <Tooltip label={value}>
        <ThemeIcon size={"xs"} c={logLevelColor} variant="transparent">
          <IconPointFilled />
        </ThemeIcon>
      </Tooltip>
    </Group>
  )
}
